import calculatorLabels from "@/constants/labels/calculators.labels.js";

export default {
    name: 'Regra de Três',
    id: calculatorLabels.RULE_OF_THREE_ID,
    classes: ['Cálculo de Doses'],
    routeName: "rule-of-three-calculator",
    sections: [],
    references: []
}